import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71a9018c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = ["id", "name", "accept"]
const _hoisted_3 = {
  key: 1,
  class: "form-control-custom mb-3 text-muted"
}
const _hoisted_4 = ["id", "name", "accept"]
const _hoisted_5 = {
  key: 0,
  class: "text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf display-4 mb-3" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h2 mb-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Clique ou arraste um arquivo ")
], -1))
const _hoisted_8 = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-7x fa-file-pdf text-danger" }, null, -1))
const _hoisted_10 = { class: "text-muted small pt-3" }

import { computed, onMounted, ref } from "vue";
import { EventBus, EventBusNames } from "@/utils/EventBus";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
    accept: { default: "image/*,.pdf" },
    customFileInputWidth: { default: 100 },
    inputId: { default: () => `def-${new Date().getTime()}` },
    hiddenInput: { type: Boolean, default: false },
    maxFileSize: { default: 15 }
  },
  emits: ["fileUploaded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const originalFile = ref<File | null>(null);

const fileName = computed(() => (originalFile.value ? `${originalFile.value.name}` : ``));
const input_name = computed(() => `${props.inputId}-name`);

onMounted(() => {
  EventBus.$on(EventBusNames.CLEAR_FILE_UPLOADER, () => {
    originalFile.value = null;
  });
});

const inputChanged = (e: any) => {
  originalFile.value = e.target.files[0];
  emit("fileUploaded", { file: originalFile.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hiddenInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("input", {
            hidden: "",
            id: _ctx.inputId,
            ref: input_name.value,
            type: "file",
            name: input_name.value,
            accept: _ctx.accept,
            onChange: inputChanged,
            style: _normalizeStyle({ width: _ctx.customFileInputWidth + 'px' })
          }, null, 44, _hoisted_2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("input", {
            id: _ctx.inputId,
            ref: input_name.value,
            type: "file",
            name: input_name.value,
            accept: _ctx.accept,
            onChange: inputChanged,
            style: _normalizeStyle({ width: _ctx.customFileInputWidth + 'px' })
          }, null, 44, _hoisted_4),
          (!originalFile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("small", null, "Tamanho máximo: " + _toDisplayString(_ctx.maxFileSize) + "mb", 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", _hoisted_10, _toDisplayString(fileName.value), 1)
              ]))
        ]))
  ]))
}
}

})